import { Pipe, PipeTransform } from '@angular/core';
import { isDate, isValid, add, isBefore, isAfter, sub } from 'date-fns';

@Pipe({
  name: 'isBeforeInMinutes',
})
export class IsBeforeInMinutes implements PipeTransform {
  public transform(value: Date | string, minuteToAdd: number): boolean {
    if (!value) {
      return false;
    }
    if (typeof value === 'string') {
      value = new Date(value);
    }
    let asDate: Date = value;
    if (!isDate(value)) {
      asDate = new Date(value);
    }
    if (!isValid(asDate)) {
      return false;
    }
    const newDate = new Date();
    const tempDate = sub(newDate, { minutes: minuteToAdd });
    return isBefore(asDate, tempDate);
  }
}
